/* Room Studio entry adapter. No cart, API, geolocation, upload or polling. */
(() => {
  'use strict';
  // Shared theme blocks can be rendered more than once, and dynamically replaced.
  // One adapter owns all current/future entries on the page.
  if (window.__seegartRoomEntryInitialized) return;
  window.__seegartRoomEntryInitialized = true;
  const copy = {
    en: ['See it in a room', 'Compare sizes & frames in 7 room scenes', 'Illustrative room preview', 'Choose a product option to open the room preview.'],
    zh: ['查看上墙效果', '在 7 种房间场景中比较尺寸与装框', '房间效果仅供参考', '请选择商品规格后查看上墙效果。'],
    es: ['Míralo en un espacio', 'Compara tamaños y marcos en 7 ambientes', 'Vista de habitación ilustrativa', 'Elige una opción del producto para abrir la vista del espacio.'],
    fr: ['Voir dans une pièce', 'Comparez tailles et cadres dans 7 pièces', 'Aperçu de pièce illustratif', 'Choisissez une option du produit pour ouvrir l’aperçu.'],
    de: ['Im Raum ansehen', 'Größen und Rahmen in 7 Räumen vergleichen', 'Illustrative Raumvorschau', 'Wähle eine Produktoption, um die Raumvorschau zu öffnen.'],
    it: ['Guardalo in una stanza', 'Confronta misure e cornici in 7 ambienti', 'Anteprima illustrativa della stanza', 'Scegli un’opzione del prodotto per aprire l’anteprima.'],
    pt: ['Veja em um ambiente', 'Compare tamanhos e molduras em 7 ambientes', 'Prévia ilustrativa do ambiente', 'Escolha uma opção do produto para abrir a prévia.'],
    ja: ['お部屋に飾ってみる', '7 種類のお部屋でサイズと額装を比較', 'お部屋のイメージプレビュー', '商品オプションを選んでプレビューを開いてください。']
  };
  const enhanced = new WeakSet();
  // Verified @shopify/events StandardEvents.productSelect value. The promise is
  // on the event itself, and resolves to an event with detail.resource.
  const productSelectEvent = 'shopify:product:select';
  const numericId = value => typeof value === 'string' && /^[1-9]\d{0,19}$/.test(value.trim()) ? value.trim() : null;
  // Handles are opaque single path segments, not URLs; retain non-Latin names.
  const productHandle = value => typeof value === 'string' && value.length > 0 && value.length <= 255 && !/[\s/\\?#%\u0000-\u001f\u007f]/.test(value) && !['.', '..'].includes(value) ? value : null;
  function language() {
    const code = (document.documentElement.lang || 'en').toLowerCase().replace(/_/g, '-').split('-')[0];
    return copy[code] || copy.en;
  }
  function element(tag, className, text) {
    const node = document.createElement(tag); node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function roomIcon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 32 32'); svg.setAttribute('class', 'sg-room-entry__icon');
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M4 27V5h24v22M4 27h24M10 9h12v9H10zM8 27v-5h16v5M11 22v-3m10 3v-3');
    path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5'); path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round'); svg.appendChild(path); return svg;
  }
  function ensureMarkup(anchor) {
    anchor.classList.add('sg-room-entry');
    let visual = anchor.querySelector('.sg-room-entry__visual');
    if (!visual) { visual = element('span', 'sg-room-entry__visual'); anchor.appendChild(visual); }
    visual.setAttribute('aria-hidden', 'true');
    if (!visual.querySelector('img,svg')) visual.appendChild(roomIcon());
    const thumb = visual.querySelector('img');
    if (thumb) { thumb.alt = ''; thumb.loading = 'lazy'; thumb.decoding = 'async'; }
    let text = anchor.querySelector('.sg-room-entry__text');
    if (!text) { text = element('span', 'sg-room-entry__text'); anchor.appendChild(text); }
    let title = text.querySelector('.sg-room-entry__title');
    if (!title) { title = element('span', 'sg-room-entry__title'); text.appendChild(title); }
    let subtitle = text.querySelector('.sg-room-entry__subtitle');
    if (!subtitle) { subtitle = element('span', 'sg-room-entry__subtitle'); text.appendChild(subtitle); }
    if (!anchor.querySelector('.sg-room-entry__arrow')) {
      const arrow = element('span', 'sg-room-entry__arrow', '→'); arrow.setAttribute('aria-hidden', 'true'); anchor.appendChild(arrow);
    }
    let note = anchor.querySelector('.sg-room-entry__note');
    if (!note) { note = element('span', 'sg-room-entry__note'); anchor.appendChild(note); }
    const labels = language(); title.textContent = labels[0]; subtitle.textContent = labels[1]; note.textContent = labels[2];
    return {title, subtitle, note};
  }
  function exactForm(anchor) {
    const id = (anchor.dataset.productFormId || '').trim();
    if (!id) return null;
    const form = document.getElementById(id);
    return form && form.tagName === 'FORM' ? form : null;
  }
  function liveVariant(form) {
    // form.elements includes controls explicitly associated with this exact form.
    // Duplicate effective IDs must agree; an ambiguous or empty form stays disabled.
    const values = Array.from(form.elements).filter(control => control.form === form && control.name === 'id' && !control.disabled && !['button', 'submit', 'reset', 'image'].includes(control.type) && (!['radio', 'checkbox'].includes(control.type) || control.checked)).map(control => numericId(String(control.value || '')));
    if (!values.length || values.some(value => !value) || new Set(values).size !== 1) return null;
    return values[0];
  }
  function destination(anchor) {
    const productId = numericId(anchor.dataset.productId || '');
    const form = exactForm(anchor);
    if (!productId || !form) return null;
    const variantId = liveVariant(form);
    if (!variantId) return null;
    const path = (anchor.dataset.previewUrl || '').trim();
    if (!path) return null;
    let url;
    try { url = new URL(path, window.location.href); } catch (_) { return null; }
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin || url.username || url.password) return null;
    url.searchParams.set('product', productId); url.searchParams.set('variant', variantId);
    // Additive contract: legacy ID-only entries continue to work, while every
    // newly rendered product supplies its handle for live storefront lookup.
    const handle = productHandle(anchor.dataset.productHandle);
    if (handle) url.searchParams.set('handle', handle); else url.searchParams.delete('handle');
    return {url: url.href, variantId};
  }
  function enhance(anchor) {
    if (enhanced.has(anchor) || anchor.tagName !== 'A') return;
    enhanced.add(anchor);
    const nodes = ensureMarkup(anchor);
    const originalTabIndex = anchor.getAttribute('tabindex');
    const selection = {sequence: 0, pending: false, failed: false, expectedVariant: null};
    function update(event) {
      let target = selection.pending || selection.failed ? null : destination(anchor);
      if (target && selection.expectedVariant) {
        // Promise completion and form morphing can happen in different handlers.
        // Do not navigate with the old hidden ID before the form catches up.
        if (target.variantId !== selection.expectedVariant) target = null;
        else selection.expectedVariant = null;
      }
      const labels = language();
      nodes.title.textContent = labels[0]; nodes.subtitle.textContent = labels[1];
      if (target) {
        anchor.href = target.url; anchor.dataset.variantId = target.variantId;
        anchor.removeAttribute('aria-disabled'); nodes.note.textContent = labels[2];
        if (originalTabIndex === null) anchor.removeAttribute('tabindex'); else anchor.setAttribute('tabindex', originalTabIndex);
      } else {
        anchor.removeAttribute('href'); anchor.setAttribute('aria-disabled', 'true'); anchor.setAttribute('tabindex', '0');
        nodes.note.textContent = labels[3];
        if (event && ['click', 'auxclick'].includes(event.type)) event.preventDefault();
      }
      // Valid clicks retain normal anchor navigation, modifiers, target and download semantics.
    }
    ['click', 'auxclick', 'contextmenu', 'pointerdown', 'focus'].forEach(name => anchor.addEventListener(name, update, true));
    const form = exactForm(anchor);
    if (form) { form.addEventListener('change', update, true); form.addEventListener('input', update, true); }
    const section = form && form.closest('.shopify-section');
    if (section && anchor.closest('.shopify-section') === section) {
      section.addEventListener(productSelectEvent, event => {
        const target = event.target;
        if (!target || typeof target.closest !== 'function' || target.closest('product-card') || target.closest('.shopify-section') !== section) return;
        const productContext = target.closest('[data-product-id]');
        const contextualId = productContext && numericId(String(productContext.dataset.productId || ''));
        const productId = numericId(anchor.dataset.productId || '');
        if (contextualId && contextualId !== productId) return;
        const sequence = ++selection.sequence;
        selection.pending = true; selection.failed = false; selection.expectedVariant = null; update();
        if (!event.promise || typeof event.promise.then !== 'function') {
          selection.pending = false; selection.failed = true; update(); return;
        }
        Promise.resolve(event.promise).then(result => {
          if (sequence !== selection.sequence) return;
          const detail = result && result.detail;
          const resolvedProductId = detail && numericId(String(detail.productId || ''));
          const resolvedVariantId = detail && detail.resource && numericId(String(detail.resource.id || ''));
          selection.pending = false;
          selection.failed = !resolvedVariantId || resolvedProductId !== productId;
          selection.expectedVariant = selection.failed ? null : resolvedVariantId;
          update();
          if (!selection.failed) {
            // Our capture listener can settle before Dwell's product-form handler
            // writes its hidden input. Recheck after the current promise reactions,
            // then at most one frame later. Never infer the variant from the URL.
            return Promise.resolve().then(() => {
              if (sequence !== selection.sequence) return;
              update();
              if (selection.expectedVariant && typeof window.requestAnimationFrame === 'function') {
                window.requestAnimationFrame(() => {
                  if (sequence === selection.sequence) update();
                });
              }
            });
          }
        }).catch(() => {
          if (sequence !== selection.sequence) return;
          selection.pending = false; selection.failed = true; selection.expectedVariant = null; update();
        });
      }, true);
    }
    update();
  }
  function initialize(scope) {
    if (scope.matches && scope.matches('[data-seegart-room-entry]')) enhance(scope);
    scope.querySelectorAll('[data-seegart-room-entry]').forEach(enhance);
  }
  function start() {
    initialize(document);
    // Dwell combined-product selections can replace <main> without dispatching
    // shopify:section:load. Inspect added subtrees only; no polling or attributes.
    if (typeof MutationObserver === 'function') {
      const observer = new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(node => {
          if (node.nodeType === 1 && typeof node.querySelectorAll === 'function') initialize(node);
        }));
      });
      observer.observe(document.body || document.documentElement, {childList: true, subtree: true});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
